export const isScheduleOnceType = function(expression) {
  return expression.match(/^(\d+) (\d+) (\d+) (\d+) \? (\d+)$/) !== null
}
